var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('path',{attrs:{"d":"M7.5 6.667H5V10h2.5v10h4.167V10h3.035L15 6.667h-3.333v-1.39c0-.795.16-1.11.929-1.11H15V0h-3.173C8.83 0 7.5 1.32 7.5 3.846v2.82z"}})}
var staticRenderFns = []

export { render, staticRenderFns }